/**************************************************
 * Nombre:       Tarjeta_Deposito
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {FONDOCARD} from "../../Constantes";
import BotonTransparente from "./Componentes/BotonTransparente";
import {Task} from "@mui/icons-material";
import lite from '../../Recursos/lite.svg'
import usdt from '../../Recursos/usdt.svg'
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Depositar from "../Dialogos/Dialogo_Depocitar";
import {useContext, useEffect, useState} from "react";
import {obtenerTotalDepositos} from "../../CodigoCliente/Depositos/obtenerTotalDepositos";
import {usuarioContext} from "../../App";
import {formatoMonedaTabla} from "../../Modulo_Tabla_2025/Utilidades/formatoMonedaTabla";
import Dialogo_Contrato from "../Dialogos/Dialogo_Contrato";

const Tarjeta_Deposito = () => {
    const {masSM} = useResponsive()
    const cData = useContext(usuarioContext)
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Depositar, titulo: 'Depositos'})
    const {Dialogo:DialogoContrato, abrir:abrirContrato} = useDialogo({Componente: Dialogo_Contrato, titulo: 'Detalles del contrato'});
    const [totalDepositos, setTotalDepositos] = useState(0)

    useEffect(() => {

        obtenerTotalDepositos(cData.usuario.id).then((dox) => {
            setTotalDepositos(dox)
        })

    }, [])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-end'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                ...FONDOCARD,
                p: 2,
                color: '#fff',
                minHeight: 170
            }}
        >

            <Dialogo/>

            <DialogoContrato/>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start',}}>
                <Typography sx={{fontSize: 16, fontWeight: 400}}>Wallet de Depósito</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                <Typography
                    sx={{fontSize: 24, fontWeight: 600}}>{`${formatoMonedaTabla(totalDepositos, 2)} USD`}</Typography>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start', mt: !masSM ? 2 : 0}}>
                <BotonTransparente titulo={'Hacer Nuevo Contrato'} Icono={Task} click={abrirContrato}/>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                <Button
                    onClick={() => abrir()}
                    fullWidth

                >
                    <span>
                        <img src={lite} width={22} height={'auto'}
                             style={{marginRight: 2, marginBottom: -5, marginTop: 1}}/>
                    </span>
                    <span>
                        <img src={usdt} width={22} height={'auto'}
                             style={{marginRight: 8, marginBottom: -5, marginTop: 1}}/>
                    </span>
                    Depositar
                </Button>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Deposito